import ModalRoot from "components/Modal";
import useSharepointAuthReturn from "hooks/sharepoint/useSharepointAuthReturn";
import React from "react";
import { useSelector } from "react-redux";

const ModalsHolder = () => {
  const modals = useSelector((state) => state.modals);

  useSharepointAuthReturn();
  return (
    <>
      {modals.map((modal) => (
        <ModalRoot
          key={modal.modalType}
          modalType={modal.modalType}
          modalProps={modal.modalProps}
        />
      ))}
    </>
  );
};

export default ModalsHolder;
